import { render } from "./TfAuth.vue?vue&type=template&id=019c87fe"
import script from "./TfAuth.vue?vue&type=script&lang=js"
export * from "./TfAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__